import CLAUSE_DATA from '../data/clauses.json';

// Robust frontend-only clause & snippet generator with professional legal text
export function generateClause({ documentType = '', jurisdiction = '', tone = 'Formal', year = '', complexity = 'Medium', persona = 'Analyst', mode = 'Draft Clause' } = {}) {
  const dt = (documentType || '').toLowerCase()
  const j = (jurisdiction || '').toLowerCase()
  const c = (complexity || 'Medium')

  const prefixes = CLAUSE_DATA.prefixes;
  const prefix = prefixes[persona] || prefixes['Analyst'];

  let clauseType = 'General'
  let clause = ''

  const CLAUSE_LIBRARY = CLAUSE_DATA.library;

  // Selection Logic
  if (dt.includes('contract') || dt.includes('agreement')) {
    const keys = Object.keys(CLAUSE_LIBRARY.contract);
    clauseType = keys[Math.floor(Math.random() * keys.length)];
    clause = CLAUSE_LIBRARY.contract[clauseType];
    clauseType = clauseType.charAt(0).toUpperCase() + clauseType.slice(1);
  } else if (dt.includes('gdpr') || j.includes('eu')) {
    const keys = Object.keys(CLAUSE_LIBRARY.gdpr);
    clauseType = keys[Math.floor(Math.random() * keys.length)];
    clause = CLAUSE_LIBRARY.gdpr[clauseType];
    clauseType = clauseType.charAt(0).toUpperCase() + clauseType.slice(1);
  } else if (dt.includes('bank') || dt.includes('finance')) {
    const keys = Object.keys(CLAUSE_LIBRARY.banking);
    clauseType = keys[Math.floor(Math.random() * keys.length)];
    clause = CLAUSE_LIBRARY.banking[clauseType];
    clauseType = clauseType.charAt(0).toUpperCase() + clauseType.slice(1);
  } else if (j.includes('nepal') || j === 'np') {
    const keys = Object.keys(CLAUSE_LIBRARY.nepal);
    clauseType = keys[Math.floor(Math.random() * keys.length)];
    clause = CLAUSE_LIBRARY.nepal[clauseType];
    clauseType = clauseType.charAt(0).toUpperCase() + clauseType.slice(1);
  } else {
    const keys = Object.keys(CLAUSE_LIBRARY.general);
    clauseType = keys[Math.floor(Math.random() * keys.length)];
    clause = CLAUSE_LIBRARY.general[clauseType];
    clauseType = clauseType.charAt(0).toUpperCase() + clauseType.slice(1);
  }

  // Tone adjustments
  if (tone === 'Concise') {
    // Heuristic to shorten: take first sentence or first 200 chars
    const firstSentence = clause.split('. ')[0] + '.';
    clause = firstSentence.length > 20 ? firstSentence : clause;
  } else if (tone === 'Detailed') {
    clause += ' Furthermore, the parties acknowledge that strict adherence to these provisions is material to the agreement, and any deviation shall require prior written consent.';
  }

  // Complexity adjustments
  if (c === 'High') {
    clause = clause.replace(/shall/g, 'must strictly').replace(/agrees to/g, 'covenants to');
    clause += ' This obligation is absolute and unconditional.';
  }

  // Mode adjustments
  if (mode === 'Explain') {
    clause = `${prefix}\n\n**Explanation:** The proposed clause addresses ${clauseType.toLowerCase()} by establishing clear obligations. It is designed to mitigate risk by ${clause.includes('indemnify') ? 'shifting liability' : 'ensuring compliance'}. \n\n**Draft Text:**\n"${clause}"`;
  } else if (mode === 'Rewrite') {
    clause = `${prefix}\n\n**Revised Draft:**\n"${clause}"`;
  } else if (mode === 'Draft Clause') {
    clause = `${prefix}\n\n"${clause}"`;
  }

  return { id: Math.random().toString(36).slice(2, 9), text: clause.trim(), clauseType }
}

export function generateSnippets({ fileName = '', metadata = {} } = {}) {
  const base = fileName || metadata?.title || 'the Document'
  const jurisdiction = metadata?.jurisdiction || 'Applicable Jurisdiction'

  let snippets = CLAUSE_DATA.snippets.map(s => ({
    ...s,
    text: s.text.replace('{jurisdiction}', jurisdiction)
  }));

  // Shuffle and return 3-4 snippets
  return snippets.sort(() => 0.5 - Math.random()).slice(0, 4);
}
